type FsvOverDurationParams = {
  isFullServiceVenue: boolean | undefined;
  minBookingDurationHours: number | undefined;
  selectedDurationHours: number | undefined;
};

type FsvOverDurationState = {
  displayHours: number;
  exceedsMinDuration: boolean;
  minBookingDurationHours: number;
};

/**
 * Derives FSV over-duration UI state: whether selected hours exceed the host
 * package length, and which hour count the fee calc should display.
 */
export const getFsvOverDurationState = ({
  isFullServiceVenue,
  minBookingDurationHours,
  selectedDurationHours,
}: FsvOverDurationParams): FsvOverDurationState => {
  const minHours = minBookingDurationHours ?? 0;
  const selectedHours = selectedDurationHours ?? 0;
  const exceedsMinDuration =
    !!isFullServiceVenue && minHours > 0 && selectedHours > minHours;

  return {
    displayHours: selectedHours || minHours,
    exceedsMinDuration,
    minBookingDurationHours: minHours,
  };
};
